import React from "react";
import Footer from "../Common/Footer";
import DocumentMeta from "react-document-meta";
import { ProductName } from "../Common/ProductName";
import DownloadHeader from "../Homepage/HomepageElements/DownloadHeader";


const Download = () => {
  const meta = {
    title: `Download | ${ProductName}  Exchange`,
    description: `Download User Friendly Crypto Exchange App, A Secure Crypto Exchange Platform For BTC, ETH, TRX, DOGE & Other Crypto Currencies In India. Visit ${ProductName}  Exchange Live Website.`,
    canonical: `https://${ProductName}  Exchange.in/download`,
    meta: {
      charset: "utf-8",
      name: {
        keywords:
          "Crypto Platform, Cryptocurrencies App, Indian Crypto Exchange, Bitcoin Exchange",
      },
    },
  };
  return (
    <div>
      <DocumentMeta {...meta}>
        <div>
          <DownloadHeader />
        </div>
      </DocumentMeta>
      <Footer />
    </div>
  );
};

export default Download;
